import Lottie from "lottie-react";
import LottieIcon from "./ValidFeedbackSuccess.json";

const ValidFeedbackComponent = ({ className }) => {
  return (
    <Lottie
      animationData={LottieIcon}
      loop={false}
      autoplay={true}
      className={`tw-w-7 ${className ?? ""} `}
    />
  );
};

export default ValidFeedbackComponent;
